import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { toast } from "sonner";

const CartContext = createContext(null);
const KEY = "lumen_cart_v1";
export const FREE_SHIPPING = 60;
export const SHIPPING_FEE = 4.9;
export const SERVICE_FEE = 1;

const load = () => {
  try {
    const v = JSON.parse(localStorage.getItem(KEY));
    return Array.isArray(v) ? v : [];
  } catch {
    return [];
  }
};

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(load);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const add = (p, qty = 1) => {
    setItems((prev) => {
      const found = prev.find((i) => i.id === p.id);
      if (found) return prev.map((i) => (i.id === p.id ? { ...i, qty: Math.min(20, i.qty + qty) } : i));
      return [...prev, { id: p.id, name: p.name, price: p.price, image: p.image, type: p.type, qty }];
    });
    toast.success(`${p.name} ajouté au panier`);
    setOpen(true);
  };
  const setQty = (id, qty) =>
    setItems((prev) => (qty <= 0 ? prev.filter((i) => i.id !== id) : prev.map((i) => (i.id === id ? { ...i, qty: Math.min(20, qty) } : i))));
  const clear = () => setItems([]);

  const totals = useMemo(() => {
    const subtotal = items.reduce((s, i) => s + i.price * i.qty, 0);
    const hasPhysical = items.some((i) => i.type === "physique");
    const shipping = hasPhysical && subtotal < FREE_SHIPPING ? SHIPPING_FEE : 0;
    const count = items.reduce((s, i) => s + i.qty, 0);
    const serviceFee = items.length ? SERVICE_FEE : 0;
    return { subtotal, shipping, serviceFee, total: subtotal + shipping + serviceFee, hasPhysical, count };
  }, [items]);

  return (
    <CartContext.Provider value={{ items, add, setQty, clear, open, setOpen, ...totals }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
